var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeroSection',[_c('HeroPage',{attrs:{"msg":"Professional Graphic Designer"}})],1),_c('AboutSection'),_c('ServiceSection'),_c('SkillSection'),_c('ProjectSection'),_c('ClientSection'),_c('FormSection'),_c('NewsSection'),_c('FooterSection',[_c('FooterLogo'),_c('FooterMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }